import { EMessageV2Status } from '@cian/chats-api';

import { EStatus } from '../../repositories/chats/entities/message_list_item_v2/MessageListItemV2Schema';

const MESSAGE_STATUS = {
  [EStatus.Deleted]: EMessageV2Status.Deleted,
  [EStatus.DeliveredToServer]: EMessageV2Status.DeliveredToServer,
  [EStatus.ReadByRecipient]: EMessageV2Status.ReadByRecipient,
};

export const mapStatusMessage = (status: EStatus): EMessageV2Status => {
  const newStatus = MESSAGE_STATUS[status];
  if (newStatus) {
    return newStatus as EMessageV2Status;
  } else {
    return EMessageV2Status.DeliveredToServer;
  }
};
